<template>
    <div class="reseller-password-reset">
        <div class="container">
            <div class="row justify-center">
                <div class="md:w-1/2 lg:w-5/12 w-full">
                    <div class="lg:px-20">
                        <div class="text-center">
                            <h1 class="h4 mb-8">{{ translations.reset_title }}</h1>
                            <p class="mb-40">{{ translations.reset_description }}</p>
                        </div>

                        <el-form class="mb-24" @submit="submit" :loading="loading" :success="success" :error="server_error" button-class="btn btn-green btn-lg btn-rounded w-full mt-8 font-bold" submit-text="registreer">
                            <el-input v-model="formData.email" type="email" :disabled="true" rules="required" label="E-mail" class="mb-16"></el-input>
                            <el-input v-model="formData.first_name" rules="required" label="Voornaam" class="mb-16"></el-input>
                            <el-input v-model="formData.last_name" rules="required" label="Achternaam" class="mb-16"></el-input>
                            <el-input v-model="formData.password" type="password" :rules="{ required: true, min: 8, regex: /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/ }" :label="translations.password_field" class="mb-16"></el-input>
                            <el-input v-model="formData.repeatPassword" type="password" :rules="{ required: true, is: formData.password, min: 8, regex: /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/ }" :label="translations.password_repeat_field" class="mb-16"></el-input>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import hasForm from "@mixins/components/has-form";

export default {
    name: "Ui.ResellerInvite",

    mixins: [hasForm],

    props: {
        translations: {
            type: Object,
            required: true
        },
        inviteData: {
            type: Object,
            required: true
        },
        code: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            formData: {
                email: "",
                first_name: "",
                last_name: "",
                password: "",
                repeatPassword: "",
                locale: "nl_BE",
                invite_code: ""
            }
        };
    },

    methods: {
        submit() {
            this.beforeSubmit();

            axios
                .post("/api/invite", this.formData)
                .then(response => {
                    this.handleSuccess();
                    window.location.replace("/login?action=registered");
                })
                .catch(e => this.handleError(e));
        }
    },

    watch: {
        inviteData: {
            deep: true,
            immediate: true,
            handler: function(val) {
                if (val && val.data) {
                    this.formData.email = val.data.prefilled_data.email;
                    this.formData.first_name = val.data.prefilled_data.first_name;
                    this.formData.last_name = val.data.prefilled_data.last_name;
                    this.formData.locale = val.data.locale;
                }
            }
        },
        code: {
            immediate: true,
            handler: function(val) {
                this.formData.invite_code = val;
            }
        }
    }
};
</script>
